import {
  AdvancedFilterDataSchema,
  FilterGroupSchema,
} from "@redotech/redo-views-common/advanced-filters/advanced-filter-data";
import * as z from "zod";

export const createInventoryLevelLedgerExport = {
  name: "createInventoryLevelLedgerExport" as const,
  input: z.object({
    filters: z.array(AdvancedFilterDataSchema),
    filterGroup: FilterGroupSchema.nullish(),
    sendToEmail: z.string().email(),
  }),
  output: z.object({ exportId: z.string() }),
};
